import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling the animation of the interior hero text wrapper
 */
export default class InteriorHero extends MessageBus {
  /**
   * Constructor function of the InteriorHero class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {HTMLElement} element - The container element
     */
    this.element = element;

    this.init();
  }

  /**
   * Initializes the view by setting up the scroll event listener
   * @returns {InteriorHero} A reference to the current instance of the class
   * @chainable
   */
  init() {
    window.addEventListener(EVENTS.LOAD, () => {
      const textWrapperWithImage = this.element.querySelector(
        `.${CLASS_NAMES.INTERIOR_HERO_TEXT_WRAPPER}.${CLASS_NAMES.WITH_IMAGE}`
      );

      const textWrapperWithoutImage = this.element.querySelector(
        `.${CLASS_NAMES.INTERIOR_HERO_TEXT_WRAPPER}.${CLASS_NAMES.NO_IMAGE}`
      );

      const rightWrapper = this.element.querySelector(
        `.${CLASS_NAMES.INTERIOR_HERO_RIGHT_WRAPPER}`
      );

      const contentWrapper = this.element.querySelector(
        `.${CLASS_NAMES.HERO_CAMPAIGN_CONTENT}`
      );

      const postContentWrapper = this.element.querySelector(
        `.${CLASS_NAMES.HERO_CAMPAIGN_POST_CONTENT}`
      );

      const landingContentWrapper = this.element.querySelector(
        `.${CLASS_NAMES.LANDING_HERO_VIDEO_TEXT_WRAPPER}`
      );

      if (textWrapperWithImage) {
        textWrapperWithImage.classList.add(CLASS_NAMES.ANIMATE);
      }

      if (textWrapperWithoutImage) {
        textWrapperWithoutImage.classList.add(CLASS_NAMES.FADE);
      }

      if (rightWrapper) {
        rightWrapper.classList.add(CLASS_NAMES.ANIMATE);
      }

      if (contentWrapper) {
        contentWrapper.classList.add(CLASS_NAMES.ANIMATE);
      }

      if (postContentWrapper) {
        postContentWrapper.classList.add(CLASS_NAMES.ANIMATE);
      }

      if (landingContentWrapper) {
        landingContentWrapper.classList.add(CLASS_NAMES.ANIMATE);
      }
    });

    return this;
  }
}
